import { render, staticRenderFns } from "./YouAndMeTextTitle.vue?vue&type=template&id=4698759a&scoped=true&"
import script from "./YouAndMeTextTitle.vue?vue&type=script&lang=js&"
export * from "./YouAndMeTextTitle.vue?vue&type=script&lang=js&"
import style0 from "./YouAndMeTextTitle.vue?vue&type=style&index=0&id=4698759a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4698759a",
  null
  
)

export default component.exports